import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.0.3_@babel+core@7.29.0_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
